<template>
  <div>
    <section>
      <v-card style="background-color: #ECEFF1">
        <v-container container--fluid>
          <v-row align="center" justify="center">
            <v-col cols="10" sm="10" md="3" class="text-center">
              <h1>Client Applications</h1>
            </v-col>
            <v-col cols="10" sm="10" md="1" class="text-center">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn color="blue darken-1 headline" text v-on="on" @click="info = !info">
                    <span class="v-btn__content" style="font-size: 22px;">?</span>
                  </v-btn>
                </template>
                <span>Display information about this page</span>
              </v-tooltip>
            </v-col>
            <v-col cols="10" sm="10" md="3">
              <v-text-field
                v-model="search"
                clearable
                prepend-inner-icon="search"
                label="Search...">
              </v-text-field>
            </v-col>
            <v-col cols="10" sm="10" md="2" class="text-center">
              <v-switch
                label="Show Opened"
                v-model="allSwitch"
                style="justify-content: center; display: flex;"
              ></v-switch>
            </v-col>
            <v-col cols="10" sm="10" md="3" class="text-center">
              <v-menu bottom left :close-on-content-click="false" v-model="menu">
                <template v-slot:activator="{ on }">
                  <v-btn outlined color="indigo" v-on="on">
                    Create application
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                   <h3>Do you want to name it ?</h3>
                  </v-card-title>
                  <v-container>
                    <v-text-field label="Application Name" v-model="applicationName">
                      <template v-slot:append>
                        <v-btn rounded small @click="createANewApplication" color="blue darken-1">OK</v-btn>
                      </template>
                    </v-text-field>
                  </v-container>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>


        <v-alert :value="info" type="info" color="blue darken-1" transition="slide-y-transition" class="mb-0">
          On this page, can only create a client once the application has been closed
        </v-alert>
        <v-divider></v-divider>
        <v-data-table
          v-if="clientApplications"
          :key="keyDataTable"
          :items="renderedApplications"
          :search="search"
          :headers="headers"
        >
          <template v-slot:item="props">
            <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
              <td @click="showForm(props.item)" style="text-align: center">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-icon :color="props.item.closed ? '#BDBDBD' : 'orange'" v-on="on">fiber_manual_record
                    </v-icon>
                  </template>
                  <span>This application is {{props.item.closed ? '' : 'not '}}closed</span>
                </v-tooltip>
              </td>
              <td @click="showForm(props.item)" style="text-align: center">{{props.item.name}}</td>
              <td @click="showForm(props.item)" style="text-align: center">{{props.item.key}}</td>
              <td @click="showForm(props.item)" style="text-align: center">{{props.item.created_by}}</td>
              <td style="text-align: center">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-icon color="green" @click="createClient(props.item)" v-on="on" :disabled="!props.item.closed">
                      screen_share
                    </v-icon>
                  </template>
                  <span>Create this client</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog width="600px" v-model="dialog" persistent>
        <v-card>
          <v-card-title class="justify-center">
           <h3>{{dialogTitle}}</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-container pb-0>
            {{dialogMessage}}
            <p v-if="applicationKey!==null">
              Link to the application form of the client:
              <a :href="'http://localhost:8080/create_client?application_key=' + applicationKey">
                {{'http://localhost:8080/create_client?application_key=' + applicationKey}}
              </a>
            </p>
            <v-card-actions class="flex-column">
              <v-text-field
                style="width: 85%;"
                label="Who would you like to send this form to ?"
                v-model="emailTo"
              ></v-text-field>
              <v-btn color="green"
                     class="white--text"
                     @click="sendEmail"
              >
                <v-icon class="mr-2">fas fa-paper-plane</v-icon>
                Send the form by email
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-actions class="justify-center">
              <v-btn text color="blue-grey lighten-2" @click="close()">Close</v-btn>
            </v-card-actions>


          </v-container>

        </v-card>
      </v-dialog>

      <v-dialog
        v-model="formDialog"
        width="1200px"
        v-if="formDialog"
        persistent
        style="height: 400px; overflow: scroll"
        @keydown.esc="formDialog=false; client=defaultClient">
        <v-card>

          <v-card-title>
            <div class="d-inline-flex">
              <v-tooltip top color="secondary align-center">
                <template v-slot:activator="{ on }">
                  <v-icon v-if="notClosedApp" color="orange" v-on="on" large>warning</v-icon>
                </template>
                <span>This application has not been closed by the client yet</span>
              </v-tooltip>
              <h1 class="ml-4">Preview</h1>
            </div>
            <v-btn
              icon
              @click="formDialog=false; client=null; applicationKey=null; notClosedApp=false"
              class="ml-auto"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-container container--fluid grid-list-md>
            <v-row justify="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col md="4" cols="12" class="text-center flex-column">
                <v-avatar color="#64b0d7">
                  <span class="white--text headline">1</span>
                </v-avatar>
                <v-card color="#64b0d7" class="mt-2">
                  <v-card-text class="white--text text-center">Edit fields filled by client if necessary
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="4" cols="12" class="text-center flex-column">
                <v-avatar color="#0c88c2">
                  <span class="white--text headline">2</span>
                </v-avatar>
                <v-card color="#0c88c2" class="mt-2">
                  <v-card-text class="white--text text-center">
                    Approve fields you consider valid
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="4" cols="12" class="text-center flex-column">
                <v-avatar color="#083a95">
                  <span class="white--text headline">3</span>
                </v-avatar>
                <v-card color="#083a95" class="mt-2">
                  <v-card-text class="white--text text-center">
                    When done click on the orange button at the end of the form
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="center" :class="{'no-gutters': $vuetify.breakpoint.smAndDown}">
              <v-col cols="12">
                <div v-if="!client" class="text-center">
                  <v-container container--fluid grid-list-md>
                    <v-progress-circular indeterminate :size="70" :width="3" v-if="!client"
                                         color="blue darken-1">
                    </v-progress-circular>
                    <br/>
                    <span>Please wait until we load this client's information.</span>
                  </v-container>
                </div>
                <ClientForm
                  v-if="client"
                  v-on:close="formDialog=false; client=null; applicationKey=null"
                  :client-files="clientFiles"
                  :application-key="applicationKey"
                  :client="client" :readonly="notClosedApp" :edit="!notClosedApp"
                ></ClientForm>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </section>

  </div>
</template>

<script>

    import axios from 'axios'
    import ClientForm from "../../util/CreateClient/ClientForm";

    // @vuese
    // Pages where are displayed all the applications filled by new clients
    // @group Pages
    export default {
        name: "ClientApplicationPage",
        components: {ClientForm},
        data() {
            return {
                info: false,
                search: null,
                keyDataTable: 0,
                menu: false,
                applicationName: null,
                notClosedApp: false,
                allSwitch: true,
                headers: [
                    {text: 'Status', sortable: false, align: 'center'},
                    {text: 'Application Name', value: 'name', sortable: false, align: 'center'},
                    {text: 'Application Key', value: 'key', sortable: false, align: 'center'},
                    {text: 'Created by', value: 'created_by', sortable: false, align: 'center'},
                    {text: 'Actions', value: 'action', sortable: false, align: 'center', width: '10%'},
                ],
                clientApplications: null,
                dialog: false,
                dialogMessage: null,
                applicationKey: null,
                dialogTitle: null,
                emailTo: null,
                client: null,
                defaultClient: {
                    name: null,
                    company_background: null,
                    client_logo: '',
                    delivery_frequency: null,
                    anticipated_volume: [],
                    type_of_food: null,
                    production_address: null,
                    production_details: null,
                    packaging: null,
                    multiple_sizes: null,
                    size_dimensions: null,
                    heavy_box: null,
                    fit_by_pallet: null,
                    sorting_warehouse: null,
                    list_of_products: null,
                    barcode_column: null,
                    label_information: null,
                    client_label: null,
                    portal_access: null,
                    google_email: null,
                    ops_contact: [],
                    cc_contact: [],
                    other_contacts: [],
                    ops_email: null,
                    legal_name: null,
                    abn: null,
                    accounting_address: null,
                    acc_details: null,
                    payment_terms: null,
                    copy_of_response: null,
                    manifestSample: '',
                    delivery_dates: null,
                    delivery_timewindows: null,
                },
                formDialog: false,
                clientFiles: [],
                clientToBeCreated: {},
            }
        },
        methods: {
            close() {
                this.dialog = false;
                this.notClosedApp = false;
                this.applicationKey = null
            },
            sendEmail() {

            },
            showForm(item) {
                this.applicationKey = item.key;
                this.clientFiles = item.files
                let suffix = '';
                if (item.closed) {
                    suffix = '/internalcontent'
                } else {
                    this.notClosedApp = true
                }
                axios.get(process.env.API_URL + '/clientapplications/' + item.key + suffix)
                    .then((response) => {
                        if (!item.closed) {
                            this.client = response.data.client_content
                        } else {
                            this.client = response.data;
                        }
                        if (this.client === null) {
                            this.client = this.defaultClient;
                        }
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    });
                this.formDialog = true;
            },
            getApplications() {
                axios.get(process.env.API_URL + '/clientapplications')
                    .then((response) => {
                        this.clientApplications = response.data;

                        for (var i = 0; i < Object.values(this.clientApplications).length; i++) {
                            this.renderedApplications.push(Object.values(this.clientApplications)[i]);
                        }
                        // Handle All Switch
                        this.renderedApplications = this.renderedApplications.filter((application) => {
                            return !application.closed || this.allSwitch
                        });
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            displayDialog(title, message) {
                this.dialogTitle = title;
                this.dialogMessage = message;
                this.dialog = true;
            },
            createANewApplication() {
                let body = null;
                if (this.applicationName !== null) {
                    body = {name: this.applicationName};
                }
                axios.post(process.env.API_URL + '/clientapplications', body)
                    .then((response) => {
                        this.applicationKey = response.data.key;
                        this.clientApplications[response.data.key] = response.data;
                        this.renderedApplications.unshift(response.data);
                        this.keyDataTable++;
                        this.displayDialog('You created a new application', 'Here is the link to the new application form for this client' +
                            '(this form is unique)');
                        this.applicationName = null;
                    })
            },
            createClient(item) {
                axios.get(process.env.API_URL + '/clientapplications/' + item.key + '/internalcontent')
                    .then((response) => {
                        this.client = response.data;

                        this.clientToBeCreated = Object.assign({}, this.defaultClient);
                        if (this.client.approved !== undefined && this.client.approved !== null && this.client.approved.length > 0) {
                            for (var field of this.client.approved) {
                                this.clientToBeCreated[field[0]] = field[1];
                            }
                            axios.post(process.env.API_URL + '/clients', this.clientToBeCreated)
                                .then((response) => {
                                    this.$router.replace('/edit_client?id=' + response.data.id);
                                })
                        } else {
                            this.$store.commit('displaySnackbar','Make sure you approved some of the fields for this application.');
                        }

                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    });
            }
        },
        mounted() {
            this.getApplications();

        },
        computed: {
            renderedApplications() {
                let renderedApplications = [];
                for (var i = 0; i < Object.values(this.clientApplications).length; i++) {
                    renderedApplications.push(Object.values(this.clientApplications)[i]);
                }
                // Handle All Switch
                renderedApplications = renderedApplications.filter((application) => {
                    return application.closed || this.allSwitch
                });

                return renderedApplications
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/ClientApplicationPage.vue